<template>
    <modal
      modal-type="bottom-sheet"
      modal-Id="details"
      v-bind:modal-visible="readerViewState">
      <template slot="toolbar-title">
        News and Updates Reader
      </template>

      <template slot="body">
        <div
          id="rg-reader-body"
          ref="readerBody">
          <a
            class="twitter-timeline"
            href="https://twitter.com/NeilJohnston/lists/bcwildfires?ref_src=twsrc%5Etfw">
          </a>
          <div ref="placeHolder"></div>
        </div>
      </template>
    </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import modal from './modal.vue';

export default {
  name: 'ReaderView',

  components: {
    modal,
  },

  data() {
    return {
      error: false,
    };
  },

  created() {
    this.$bus.$on('modal-close-event', this.closeView);
  },

  beforeDestroy() {
    this.$bus.$off('modal-close-event');
  },

  computed: {
    ...mapState([
      'isReaderViewVisible',
    ]),

    readerViewState: {
      get() {
        return this.isReaderViewVisible;
      },
      set(value) {
        // set store
        this.setReaderViewVisible(value);
      },
    },
  },

  watch: {
    isReaderViewVisible(visible) {
      if (visible) {
        this.$nextTick(() => {
          const container = document.getElementById('rg-reader-body');
          container.scrollTop = 0;
        });
      }
    },
  },

  mounted() {
    // eslint-disable-next-line func-names
    this.$nextTick(function () {
      const twitterScript = document.createElement('script');
      twitterScript.setAttribute('src', 'https://platform.twitter.com/widgets.js');
      twitterScript.setAttribute('async', true);
      twitterScript.setAttribute('charset', 'utf-8');

      const { placeHolder } = this.$refs;
      const parent = this.$refs.readerBody;
      parent.insertBefore(twitterScript, placeHolder);
    });
  },

  methods: {
    ...mapActions([
      'setReaderViewVisible',
    ]),

    closeView() {
      this.readerViewState = false;
    },
  },

};
</script>

<style lang="less">
div#rg-reader-card {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

nav#rg-reader-toolbar {
    flex: 0 0 48px;
}

div#rg-reader-body {
    flex: 0 1 calc(100vh - 64px); ;
    overflow-y: auto;
    margin-bottom: 64px;
    padding: 0 16px;
}

</style>
